import React, { useMemo } from 'react';
import { SelectDropdown } from '../../select-dropdown/select-dropdown';
import { SDCOption } from '../../select-dropdown/sdc-option/sdc-option-wrapper';
import { GenericDropdownOption, GenericDropdownOptions } from './generic-dropdown-options';
import { useComponentId } from '../../../../hooks';

import './generic-dropdown.scss';

export interface GenericDropdownOption {
    label: string;
    value: string | number | null;
}
interface GenericDropdownProps {
    testId?: string;
    label: string;
    selected?: string | number | null;
    onChange: (value: string | number) => void;
    options: GenericDropdownOption[];
    className?: string;
    isDisabled?: boolean;
}

export const GenericDropdown: React.FC<GenericDropdownProps> = ({
    testId,
    label,
    selected,
    onChange,
    options,
    className,
    isDisabled = false,
}): React.ReactElement => {
    const dropdownOptions = useMemo<GenericDropdownOptions[]>((): GenericDropdownOptions[] => {
        return options.map((item): GenericDropdownOption => {
            const option: GenericDropdownOptions = {
                value: item.value,
                label: item.label,
                selected: selected === item.value,
                data: item,
            };

            return option;
        });
    }, [options, selected]);

    const id = useComponentId('generic-dropdown');

    return (
        <SelectDropdown
            id={id}
            ariaLabel={label}
            testId={testId}
            className={`generic-dropdown ${className}`}
            onSelect={(option: SDCOption<null>) => {
                onChange(option.value);
            }}
            options={dropdownOptions}
            ListItemComponent={GenericDropdownOption}
            isDisabled={isDisabled}
        />
    );
};
